import React from 'react'
import './download.css'
import Imgoogle from '../../assets/playStore.png'
import Imios from '../../assets/appleStore.png'
import { Link } from "react-router-dom";

const Download = () => {
  return (
    <div className='fav__download'>
        <div className='fav__download-row'>
            <div className='fav__download-row_col-1'>
                <h3>Download our mobile app for better experience</h3>
            </div>
            <div className='fav__download-row_col-2'>
              <a href="https://play.google.com/store/apps/details?id=com.favouritedoctor.android" target="_blank" rel="noreferrer">
                <div className='fav__download-row_card1'>
                <img src={Imgoogle}  alt='FavDoctor-Andriod-App' />
                </div>
              </a>
           {/*   <a href="/comingsoon">
                <div className='fav__download-row_card2'>
            
                <img src={Imios}  alt='ios' />
               
                </div>
  </a>*/}
            </div>
        </div>
    </div>
  )
}

export default Download
